module.exports = __webpack_public_path__ + "img/collection-engagementRingsDainty@2x.8789bde.jpg";